import type { ApartmentType } from '@pullman/shared';

export const MOCK_PROPERTIES: ApartmentType[] = [
  {
    id: 'type-1',
    type_number: 1,
    name: 'Type 1',
    bedrooms: { min: 2, max: 2 },
    total_area_sqm: 131.99,
    indoor_area_sqm: 117.09,
    balcony_area_sqm: 14.9,
    ceiling_height_m: 3.0,
    rooms: [
      { name: 'Living Room', area_sqm: 32.5 },
      { name: 'Master Bedroom', area_sqm: 18.2 },
      { name: 'Second Bedroom', area_sqm: 14.8 },
      { name: 'Kitchen', area_sqm: 15.6 },
      { name: 'Bathroom', area_sqm: 7.2 },
    ],
    pricing: [
      { floor_range: 'Floors 1-6', price_amd: 211184000, price_usd_approx: 545000 },
      { floor_range: 'Floors 7-11', price_amd: 237582000, price_usd_approx: 613000 },
      { floor_range: 'Floors 12-14', price_amd: 263980000, price_usd_approx: 681000 },
    ],
    floor_plan_url: 'https://cdn.prod.website-files.com/6685b27b98911d2b57296782/6685b27b98911d2b57296857_type%201%20.webp',
    render_url: 'https://cdn.prod.website-files.com/6685b27b98911d2b57296782/6685b27b98911d2b57296829_Terrace%5Bai%5D.jpg',
    features: ['Open balcony', 'Panoramic views', '3m ceiling height', 'European design'],
    recommended_for: ['Young couples', 'Small families', 'Investors'],
    orientation: 'South-East',
  },
  {
    id: 'type-2',
    type_number: 2,
    name: 'Type 2',
    bedrooms: { min: 1, max: 1 },
    total_area_sqm: 61.97,
    indoor_area_sqm: 61.97,
    balcony_area_sqm: 0,
    ceiling_height_m: 3.0,
    rooms: [
      { name: 'Living Room / Bedroom', area_sqm: 24.0 },
      { name: 'Kitchen', area_sqm: 12.5 },
      { name: 'Bathroom', area_sqm: 5.8 },
    ],
    pricing: [
      { floor_range: 'Floors 1-6', price_amd: 99152000, price_usd_approx: 256000 },
      { floor_range: 'Floors 7-11', price_amd: 111546000, price_usd_approx: 288000 },
      { floor_range: 'Floors 12-14', price_amd: 123940000, price_usd_approx: 320000 },
    ],
    floor_plan_url: 'https://cdn.prod.website-files.com/6685b27b98911d2b57296782/6685b27b98911d2b57296853_type%202%20.webp',
    render_url: 'https://cdn.prod.website-files.com/6685b27b98911d2b57296782/6685b27b98911d2b5729682e_Terrace%20dark.webp',
    features: ['Compact layout', '3m ceiling height', 'European design'],
    recommended_for: ['Singles', 'Young professionals', 'Investment buyers'],
  },
  {
    id: 'type-3',
    type_number: 3,
    name: 'Type 3',
    bedrooms: { min: 1, max: 1 },
    total_area_sqm: 74.56,
    indoor_area_sqm: 60.81,
    balcony_area_sqm: 13.75,
    ceiling_height_m: 3.0,
    rooms: [
      { name: 'Living Room', area_sqm: 20.5 },
      { name: 'Bedroom', area_sqm: 16.3 },
      { name: 'Kitchen', area_sqm: 11.8 },
      { name: 'Bathroom', area_sqm: 5.5 },
    ],
    pricing: [
      { floor_range: 'Floors 1-6', price_amd: 119296000, price_usd_approx: 308000 },
      { floor_range: 'Floors 7-11', price_amd: 134208000, price_usd_approx: 346000 },
      { floor_range: 'Floors 12-14', price_amd: 149120000, price_usd_approx: 385000 },
    ],
    floor_plan_url: 'https://cdn.prod.website-files.com/6685b27b98911d2b57296782/6685b27b98911d2b57296852_type%203%20.webp',
    render_url: 'https://cdn.prod.website-files.com/6685b27b98911d2b57296782/6685b27b98911d2b5729682f_Terrace%20dark3.webp',
    features: ['Spacious balcony', 'Panoramic views', '3m ceiling height', 'European design'],
    recommended_for: ['Singles', 'Couples', 'Remote workers'],
  },
  {
    id: 'type-6',
    type_number: 6,
    name: 'Type 6',
    bedrooms: { min: 2, max: 3 },
    total_area_sqm: 168.27,
    indoor_area_sqm: 146.2,
    balcony_area_sqm: 22.07,
    ceiling_height_m: 3.0,
    rooms: [
      { name: 'Living Room', area_sqm: 38.5 },
      { name: 'Master Bedroom', area_sqm: 20.4 },
      { name: 'Second Bedroom', area_sqm: 16.2 },
      { name: 'Third Bedroom', area_sqm: 12.8 },
      { name: 'Kitchen', area_sqm: 18.0 },
      { name: 'Bathroom 1', area_sqm: 8.2 },
      { name: 'Bathroom 2', area_sqm: 5.5 },
    ],
    pricing: [
      { floor_range: 'Floors 1-5', price_amd: 269232000, price_usd_approx: 695000 },
      { floor_range: 'Floors 7-9', price_amd: 302886000, price_usd_approx: 782000 },
    ],
    floor_plan_url: 'https://cdn.prod.website-files.com/6685b27b98911d2b57296782/6685b27b98911d2b57296855_type%206%20.webp',
    render_url: 'https://cdn.prod.website-files.com/6685b27b98911d2b57296782/6685b27b98911d2b5729682d_Green%20areas.webp',
    features: ['Large balcony', 'Flexible layout', 'Panoramic views', '3m ceiling height', 'European design'],
    recommended_for: ['Families', 'Those who love entertaining'],
  },
  {
    id: 'type-8',
    type_number: 8,
    name: 'Type 8',
    bedrooms: { min: 2, max: 4 },
    total_area_sqm: 270.92,
    indoor_area_sqm: 164.87,
    balcony_area_sqm: 106.05,
    ceiling_height_m: 3.0,
    rooms: [
      { name: 'Living Room', area_sqm: 45.0 },
      { name: 'Master Bedroom', area_sqm: 24.5 },
      { name: 'Second Bedroom', area_sqm: 18.0 },
      { name: 'Third Bedroom', area_sqm: 15.2 },
      { name: 'Fourth Bedroom', area_sqm: 13.0 },
      { name: 'Kitchen', area_sqm: 22.0 },
      { name: 'Bathroom 1', area_sqm: 10.5 },
      { name: 'Bathroom 2', area_sqm: 7.2 },
    ],
    pricing: [
      { floor_range: 'Floor 6', price_amd: 433472000, price_usd_approx: 1119000 },
      { floor_range: 'Floor 8', price_amd: 487656000, price_usd_approx: 1259000 },
      { floor_range: 'Floors 10-14', price_amd: 581840000, price_usd_approx: 1502000 },
    ],
    floor_plan_url: 'https://cdn.prod.website-files.com/6685b27b98911d2b57296782/6685b27b98911d2b57296854_type%208%20.webp',
    render_url: 'https://cdn.prod.website-files.com/6685b27b98911d2b57296782/6685b27b98911d2b57296834_Infinity%20Pool.webp',
    features: ['Premium unit', 'Massive 106 sqm balcony', 'Panoramic views', '3m ceiling height', 'European design', 'Corner position'],
    recommended_for: ['Large families', 'Luxury buyers', 'Diaspora investors'],
    orientation: 'South-West',
  },
];
